import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function TextUnderline({ children }:Props) {
  return (
        <Component>
            {children}
        </Component>
  );
}

const Component = styled.div`
    max-width: 100%;
    overflow: hidden;
    position: relative;

    &::after {
        background-color: var(--color-primary-opacity-28);
        border-radius: 3px;
        content: '';
        height: 10px;
        left: 0;
        position: absolute;
        width: 100%;
        bottom: 0;
    }
`;

export default TextUnderline;
